import { Directive, ElementRef } from '@angular/core';
import { Role } from '../../../types/shared/Role';
import { AuthService } from '../services/auth.service';
import { BaseRoleDirective } from './base-role.directive';

/**
 * Shows the element to users who may maintain sample types, sample categories and sample details.
 * The process owner inherits this right through the maintainer role (see AuthService#hasRole).
 */
@Directive({
    selector: '[canManageSampleDefinitions]',
    standalone: true
})
export class CanManageSampleDefinitionsDirective extends BaseRoleDirective {

    constructor(private authServiceRef: AuthService, el: ElementRef) {
        super(authServiceRef, el);
    }

    protected override checkRole(): boolean {
        return this.authServiceRef.hasAnyRole([
            Role.SAMPLE_STUDIO_ADMIN,
            Role.SAMPLE_STUDIO_MAINTAINER
        ]);
    }

}
